"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _angieslistReactComponents = require("angieslist-react-components");
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./imageCarousel.scss");
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context4, _context5; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context4 = ownKeys(Object(t), !0)).call(_context4, function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context5 = ownKeys(Object(t))).call(_context5, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } /* eslint-disable react/forbid-prop-types */
var ImageCarousel = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ImageCarousel, _React$Component);
  var _super = _createSuper(ImageCarousel);
  function ImageCarousel(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ImageCarousel);
    _this = _super.call(this, props);
    _this.state = {
      mainSliderNav: null,
      sideSliderNav: null,
      currentSlideNum: 0
    };
    return _this;
  }
  (0, _createClass2["default"])(ImageCarousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // We're OK with this as there's no visible side effects (despite rerender) and it's necessary
      // for react-slick right-nav implementation
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        mainSliderNav: this.mainSlider,
        sideSliderNav: this.sideSlider
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _context3;
      var _this$props = this.props,
        media = _this$props.media,
        title = _this$props.title,
        mainSliderSettings = _this$props.mainSliderSettings,
        sideSliderSettings = _this$props.sideSliderSettings,
        showSideNav = _this$props.showSideNav,
        onClick = _this$props.onClick,
        onKeyPress = _this$props.onKeyPress,
        onImageChange = _this$props.onImageChange;
      var _this$state = this.state,
        sideSliderNav = _this$state.sideSliderNav,
        mainSliderNav = _this$state.mainSliderNav,
        currentSlideNum = _this$state.currentSlideNum;
      var showSideSlider = showSideNav && media.length > 1;
      var numberOfSideSlidesToShow = media.length < 3 ? media.length : 3;
      var defaultMainSliderSettings = {
        className: 'main-slider',
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: sideSliderNav,
        lazyLoad: 'ondemand'
      };
      var defaultSideSliderSettings = {
        className: 'center',
        centerMode: true,
        slidesToShow: numberOfSideSlidesToShow,
        vertical: true,
        arrows: false,
        infinite: media.length > 2,
        focusOnSelect: true,
        asNavFor: mainSliderNav,
        lazyLoad: 'ondemand'
      };
      var ImageChange = function ImageChange(index) {
        onImageChange();
        _this2.setState({
          currentSlideNum: index
        });
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "image-carousel-container"
      }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Row, null, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
        xs: 12,
        md: showSideSlider ? 10 : 12,
        className: "showcase-slider-container"
      }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Slider, (0, _extends2["default"])({}, _objectSpread(_objectSpread({}, defaultMainSliderSettings), mainSliderSettings), {
        ref: function ref(slider) {
          _this2.mainSlider = slider;
        },
        afterChange: ImageChange
      }), (0, _map["default"])(media).call(media, function (image, index) {
        var _context, _context2;
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: image.mediaId
        }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Image, {
          id: "showcase-img-item-".concat(image.mediaId),
          onClick: onClick,
          onKeyPress: onKeyPress,
          "aria-label": "Open Modal",
          role: "button",
          tabIndex: 0,
          className: "img-main",
          src: image.url,
          title: (0, _concat["default"])(_context = "".concat(title, " - Image ")).call(_context, index),
          alt: (0, _concat["default"])(_context2 = "".concat(title, " - Image ")).call(_context2, index)
        }));
      }))), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
        xs: 0,
        md: showSideSlider ? 2 : 0,
        style: {
          display: showSideSlider ? 'block' : 'none'
        },
        className: "vertical-carousel-nav hidden-xs hidden-sm"
      }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Slider, (0, _extends2["default"])({}, _objectSpread(_objectSpread({}, defaultSideSliderSettings), sideSliderSettings), {
        ref: function ref(slider) {
          _this2.sideSlider = slider;
        }
      }), (0, _map["default"])(media).call(media, function (image) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: image.mediaId
        }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Image, {
          id: "showcase-img-item-".concat(image.mediaId),
          className: "img-side",
          src: image.url,
          title: image.title
        }));
      })))), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Row, null, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
        xs: 12,
        sm: 1,
        style: {
          width: 'max-content'
        }
      }, /*#__PURE__*/_react["default"].createElement("strong", null, (0, _concat["default"])(_context3 = "".concat(currentSlideNum + 1, " of ")).call(_context3, media.length, " "))), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
        xs: 12,
        sm: 10,
        style: {
          wordWrap: 'break-word'
        }
      }, /*#__PURE__*/_react["default"].createElement("small", null, media[currentSlideNum].description))));
    }
  }]);
  return ImageCarousel;
}(_react["default"].Component);
ImageCarousel.defaultProps = {
  showSideNav: true,
  mainSliderSettings: {},
  sideSliderSettings: {},
  onClick: function onClick() {},
  onKeyPress: function onKeyPress() {},
  onImageChange: function onImageChange() {}
};
ImageCarousel.propTypes = {
  media: _propTypes["default"].array.isRequired,
  title: _propTypes["default"].string.isRequired,
  showSideNav: _propTypes["default"].bool,
  mainSliderSettings: _propTypes["default"].object,
  sideSliderSettings: _propTypes["default"].object,
  onClick: _propTypes["default"].func,
  onKeyPress: _propTypes["default"].func,
  onImageChange: _propTypes["default"].func
};
var _default = exports["default"] = ImageCarousel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/showcase/imageCarousel.js
// module id = 6378
// module chunks = 25